<template>
  <div>
    <!-- html based redirection -->
    <meta http-equiv="refresh" content="0; url=https://anvil.live/lipi" />
  </div>
</template>

<script>
export default {
  created() {
    // incase the htmlbased redirection fails.
    window.location = "https://anvil.live/lipi";
  }
};
</script>